<template>
    <div id="report-channel-breakdown">
        <div class="overall-content">
            <div class="chart-container">
                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <WhatsappIcon color="#59C864" />
                        </div>
                        <h2>{{ $t("report.whatsappChannelDistribution") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.whatsappChannelDistribution')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.whatsapp"
                        channelType="whatsapp"
                    />
                </div>
                <a-divider />

                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <InstagramIcon />
                        </div>
                        <h2>{{ $t("report.instagramChannelDistribution") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.instagramChannelDistribution')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.instagram"
                        channelType="instagram"
                    />
                </div>
                <a-divider />

                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <MessengerIcon />
                        </div>
                        <h2>{{ $t("report.messengerChannelDistribution") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.messengerChannelDistribution')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.messenger"
                        channelType="messenger"
                    />
                </div>
                <a-divider />

                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <TrendyolIcon />
                        </div>
                        <h2>{{ $t("report.trendyolChannelDistribution") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.trendyolChannelDistribution')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.trendyol"
                        channelType="trendyol"
                    />
                </div>
                <a-divider />

                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <MetaIcon />
                        </div>
                        <h2>{{ $t("report.metaLeadsChannelDistribution") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.metaLeadsChannelDistribution')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.metaLeads"
                        channelType="meta-leads"
                    />
                </div>
                <a-divider />

                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <TelegramIcon />
                        </div>
                        <h2>{{ $t("report.chatDistributionByTelegramChannels") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.chatDistributionByTelegramChannels')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.telegram"
                        channelType="telegram"
                    />
                </div>
                <a-divider />

                <div class="chart-section">
                    <div class="title">
                        <div class="icon-wrapper">
                            <LinkedinIcon />
                        </div>
                        <h2>{{ $t("report.chatDistributionByLinkedinChannels") }}</h2>
                    </div>
                    <ChannelOverallChart
                        :title="$t('report.chatDistributionByLinkedinChannels')"
                        :filters="filters"
                        :loading="loading"
                        :data="data.linkedin"
                        channelType="linkedin"
                    />
                </div>
                <a-divider />
            </div>
        </div>
    </div>
</template>
<script>
import log2 from "../../../utils/log2";
import moment from "moment";
import { REPORT_API } from "../../../api/statistics";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import ChannelOverallChart from "../overall/ChannelOverallChart.vue";
import WhatsappIcon from "../../Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import InstagramIcon from "../../../components/svg/InstagramIcon.vue";
import MessengerIcon from "../../Pages/Chatbot/pages/integrations/svg/MessengerIcon.vue";
import TrendyolIcon from "../../Pages/Chatbot/pages/integrations/svg/TrendyolIcon.vue";
import MetaIcon from "../../Pages/Chatbot/pages/integrations/svg/MetaIcon.vue";
import TelegramIcon from "../../Pages/Chatbot/pages/integrations/svg/TelegramIcon.vue";
import LinkedinIcon from "../../Pages/Chatbot/pages/integrations/svg/LinkedinIcon.vue";

const log = log2("ChannelBreakdown");
export default {
    name: "ChannelBreakdown",
    components: {
        LinkedinIcon,
        ChannelOverallChart,
        ChartDoddleIcon,
        WhatsappIcon,
        InstagramIcon,
        MessengerIcon,
        TrendyolIcon,
        MetaIcon,
        TelegramIcon,
    },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            loading: true,
            data: {
                whatsapp: { buckets: [], timeSeriesType: "day" },
                instagram: { buckets: [], timeSeriesType: "day" },
                messenger: { buckets: [], timeSeriesType: "day" },
                trendyol: { buckets: [], timeSeriesType: "day" },
                metaLeads: { buckets: [], timeSeriesType: "day" },
                telegram: { buckets: [], timeSeriesType: "day" },
                linkedin: { buckets: [], timeSeriesType: "day" },
            },
        };
    },

    methods: {
        async fetch() {
            log("fetchData", this.filters);
            ["whatsapp", "instagram", "instagram-v2", "messenger", "trendyol", "meta-leads", "telegram", "linkedin"].forEach(
                (channelType) => {
                    const filters = this.$_.cloneDeep(this.filters);
                    filters.channelType = channelType;
                    REPORT_API.channelOverall(filters)
                        .then((res) => {
                            log("channelOverall data fetched", res);
                            this.data[channelType] = res;
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }
            );
        },
    },
    mounted() {
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
    },
};
</script>
<style lang="scss" scoped>
.icon-wrapper {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.icon-wrapper svg {
    width: 100%;
    height: 100%;
}

#report-channel-breakdown {
    width: 100%;
    height: auto;
    min-height: 100vh;
    display: flex;

    .md-progress-bar {
        position: absolute;
        top: 0;
        width: 100%;
        margin-left: -10px;
    }

    .side-menubar-wrapper {
        min-height: 100vh;
        flex: 0 0 15%;
        height: 100%;
    }

    .overall-content {
        padding: 10px;
        display: flex;
        flex-direction: column;
        position: relative;
        background: white;
        width: 100%;
        height: 100%;
        min-height: 100vh;
        position: relative;

        .chart-container {
            width: 100%;
            display: flex;
            flex-direction: column;
            gap: 20px;

            .chart-section {
                display: flex;
                flex-direction: column;
                gap: 10px;

                .title {
                    display: flex;
                    gap: 8px;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    z-index: 1;

                    h2 {
                        text-align: center;
                        font-weight: 700;
                        font-size: 22px;
                        margin: 0 !important;
                    }
                }
            }

            .header {
                width: 100%;
            }

            .chart {
                max-width: 1050px;
            }
        }
    }
}
</style>